import React, { useEffect, useState } from "react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { motion } from "framer-motion";
import {
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { Editor } from "react-draft-wysiwyg";
import {
  ContentState,
  EditorState,
  convertFromHTML,
  convertToRaw,
} from "draft-js";
import DriveFileRenameOutlineOutlinedIcon from "@mui/icons-material/DriveFileRenameOutlineOutlined";
import DeleteIcon from "@mui/icons-material/Delete";
import draftToHtml from "draftjs-to-html";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { toast } from "react-toastify";
import sendCreditAxios from "../../../utils/sendCreditAxiosService";

import axiosInterceptorInstance from "../../../utils/axios.interceptor";

const ThaOperatorCms = () => {
  const [rowData, setRowData] = useState<any>([]);

  const [operator, setOperator] = useState<any>("0");
  const [section, setSection] = useState<Number>(0);
  const [title, setTitle] = useState<string>("");
  const [shortCode, setShortCode] = useState<string>("");
  const [question, setQuestion] = useState<string>("");
  const [display_description, setDisplayDescription] = useState<string>("");
  const [editorState, setEditorState] = useState<EditorState>();
  const [editorFaqState, setEditorFaqState] = useState<EditorState>();
  const [submitRequest, setSubmitRequest] = useState<boolean>(false);
  const [country, setCountry] = useState<any>("0");
  const [product, setProduct] = useState<any>("0");
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [Open, setOpen] = useState<boolean>(false);
  const [circular, setCircular] = useState<boolean>(true);
  const [about, setAbout] = useState<any>([]);
  const [countryListN, setCountryListN] = useState<any[]>([]);
  const [preview, setPreview] = useState<boolean>(false);
  const [faqs, setFaqs] = useState<any>([]);
  const [edit_faqs, setEditFaqs] = useState<any>([]);
  const [delete_faq, setDeleteFaq] = useState<any>([]);
  const [display_faq, setDisplayFaq] = useState<string>("");
  const [isCheck, setIsCheck] = useState<boolean>(false);
  const [deleteCheck, setDeleteCheck] = useState<boolean>(false);
  const [action, setAction] = useState<boolean>(false);
  const [redeem, setRedeem] = useState<boolean>(false);
  const [customPageTitle, setCustomPageTitle] = useState<string>("");
  const [excerpt, setExcerpt] = useState<string>("");
  const [circle, setCircle] = useState<boolean>(false);

  const loadCountries = async () => {
    await fetch("/data/thacountry.json")
      .then((response) => {
        if (!response.ok) {
          throw new Error("HTTP error " + response.status);
        }
        return response.json();
      })
      .then((json: any) => {
        setCountryListN(json.thacountries);
      });
  };

  const controller = new AbortController();

  useEffect(() => {
    loadCountries();
    return () => {
      controller.abort();
    };
  }, []);

  useEffect(() => {
    if (country == "0" || country == undefined || product == "0") {
      setIsOpen(false);
      setOpen(false);
      setCircular(false);
      setCircle(false);
    } else {
      setRowData([]);
      getOperator();
      setSection(0);
      setIsOpen(true);
      setCircular(true);
      setOperator(0);
      setFaqs([]);
    }
  }, [country, product]);

  useEffect(() => {
    setCircle(false);
    if (operator != "0" && operator != undefined && section == 1) {
      getDescription(operator);
    }
    if (section == 1 && (operator == "0" || operator == undefined)) {
      getDescriptionByCountry();
    }
    if (operator != "0" && operator != undefined && section == 2) {
      getFAQ();
    }
    if (section == 2 && (operator == "0" || operator == undefined)) {
      getFAQByCountry();
    }
  }, [operator, section]);

  useEffect(() => {
    updateEditorAndDisplayFaq();
  }, [edit_faqs]);

  useEffect(() => {
    if (operator == "0" || operator == undefined) {
      setOpen(false);
    } else {
      setOpen(true);
      setShortCode(operator?.operatorShortCode || "");
      setTitle(operator?.operatorName || "");
      ClearFaq();
    }
  }, [operator]);
  +useEffect(() => {
    if (section == 0) {
      setOpen(false);
    } else {
      setOpen(true);
    }
  }, [section]);

  useEffect(() => {
    const updateEditorAndDisplayDescription = () => {
      if (about.payload) {
        const blocksFromHTML = convertFromHTML(about.payload.description);
        const contentState = ContentState.createFromBlockArray(
          blocksFromHTML.contentBlocks,
          blocksFromHTML.entityMap
        );
        const newEditorState = EditorState.createWithContent(contentState);
        updateDescription(newEditorState);
        setCustomPageTitle(about.payload.customPageTitle);
        setExcerpt(about.payload.excerpt);
      } else {
        setEditorState(EditorState.createEmpty());
        setDisplayDescription("");
        setCustomPageTitle("");
        setExcerpt("");
      }
    };

    updateEditorAndDisplayDescription();
  }, [about]);
  const updateEditorAndDisplayFaq = () => {
    if (edit_faqs && edit_faqs.answer) {
      setQuestion(edit_faqs.question);
      setRedeem(edit_faqs.isRedeem);
      const blocksFromHTML = convertFromHTML(edit_faqs.answer);
      const contentState = ContentState.createFromBlockArray(
        blocksFromHTML.contentBlocks,
        blocksFromHTML.entityMap
      );
      const newEditorState = EditorState.createWithContent(contentState);
      updateEditorAndDisplay(newEditorState);
    } else {
      setEditorFaqState(EditorState.createEmpty());
      setDisplayFaq("");
      setQuestion("");
      setRedeem(false);
    }
  };

  const updateEditorAndDisplay = (newEditorState: EditorState) => {
    setEditorFaqState(newEditorState);
    const value = draftToHtml(convertToRaw(newEditorState.getCurrentContent()));
    setDisplayFaq(value);
  };

  const onEditorFaqChange = (newEditorState: EditorState) => {
    updateEditorAndDisplay(newEditorState);
  };

  const updateDescription = (newEditorState: EditorState) => {
    setEditorState(newEditorState);

    // Get the content as raw data
    const contentState = newEditorState.getCurrentContent();
    const isEmpty =
      !contentState.hasText() || contentState.getPlainText().trim() === "";

    // Conditionally set the value
    const value = isEmpty ? "" : draftToHtml(convertToRaw(contentState));
    setDisplayDescription(value);
  };

  const onEditorStateChange = (newEditorState: EditorState) => {
    updateDescription(newEditorState);
  };

  const getOperator = async () => {
    toast.dismiss();
    await axiosInterceptorInstance
      .post(
        `/FusionHubCrm/GetOperators`,
        {
          page: 1,
          recordsPerPage: 999,
          operatorFilters: {
            countryIsoCode: country.isoCode2,
            currencyCode: "USD",
            categoryAliasName: product,
          },
        },
        { signal: controller.signal }
      )
      .then((response: any) => {
        const responseData = response?.data.payload;
        let finalData: any[] = [];
        responseData.forEach((item: any) => {
          finalData.push(item.operator);
        });
        if (finalData.length == 0) {
          toast.error("No Record Found");
          setCircular(false);
        } else {
          setRowData(finalData);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const handleSave = async () => {
    const isOperatorValid = operator !== 0 && operator !== undefined;
    const isSectionOne = section == 1;
    const isSectionTwo = section == 2;

    if (isSectionOne) {
      // Section 1 logic
      if (isOperatorValid && title !== "" && shortCode !== "") {
        AddDescription();
      } else if (!isOperatorValid) {
        AddDescriptionByCountry(); // Allow saving without operator checks
      } else {
        toast.error("Please enter the required inputs.");
      }
    } else if (isSectionTwo) {
      // Section 2 logic
      if (isOperatorValid && title !== "" && shortCode !== "") {
        CheckFaqAndDescription();
      } else if (!isOperatorValid) {
        CheckFaqAndDescriptionByCountry(); // Allow saving without operator checks
      } else {
        toast.error("Please enter the required inputs.");
      }
    } else {
      // Neither section is selected
      toast.error("Please select a valid section.");
    }
  };

  const AddDescription = async () => {
    setSubmitRequest(true);

    await axiosInterceptorInstance
      .post(`/ThaCrm/addabout`, {
        NAME: operator?.operatorName ? operator?.operatorName : null,
        CUSTOMNAME: about.payload != null ? about.payload.customName : "",
        OPERATORSHORTCODE: operator?.operatorShortCode
          ? operator?.operatorShortCode
          : null,
        CUSTOMPAGETITLE: customPageTitle ? customPageTitle : "",
        LOGO: operator.logo,
        EXCERPT: excerpt ? excerpt : "",
        SUBCATEGORYSHORTCODE: "",
        CATEGORYSHORTCODE: product,
        POPULARITYRANK: 0,
        DESCRIPTION: display_description ? display_description : "",
        countryIsoCode: country.isoCode2,
      })
      .then((res: any) => {
        const data = res.data;
        toast.success(data.message);
      })
      .catch((error: any) => {
        setSubmitRequest(false);
      })
      .finally(() => {
        setSubmitRequest(false);
      });
  };
  const AddDescriptionByCountry = async () => {
    setSubmitRequest(true);

    await axiosInterceptorInstance
      .post(`/ThaCrm/addaboutbycountry`, {
        name: country.countryName,
        customName: country.countryName,
        customPageTitle: customPageTitle ? customPageTitle : "",
        logo: country.countryLogo,
        excerpt: excerpt ? excerpt : "",
        description: display_description ? display_description : "",
        popularityRank: 0,
        isActive: true,
        countryIsoCode: country.isoCode2,
      })
      .then((res: any) => {
        const data = res.data;
        toast.success(data.message);
      })
      .catch((error: any) => {
        setSubmitRequest(false);
      })
      .finally(() => {
        setSubmitRequest(false);
      });
  };

  const getDescription = async (operator: any) => {
    try {
      const response = await axiosInterceptorInstance.get(
        `/ThaCrm/getabout?operatorShortCode=${
          operator?.operatorShortCode ? operator?.operatorShortCode : null
        }&countryIsoCode=${country.isoCode2}`
      );
      const responseData = response.data;
      setAbout(responseData);
      toast.info(responseData.message);
    } catch (error) {
      console.error(error);
    }
  };
  const getDescriptionByCountry = async () => {
    try {
      const response = await axiosInterceptorInstance.get(
        `/ThaCrm/getaboutbycountry?countryIsoCode=${country.isoCode2}`
      );
      const responseData = response.data;
      setAbout(responseData);
      toast.info(responseData.message);
    } catch (error) {
      console.error(error);
    }
  };

  const getFAQ = async () => {
    setCircle(true);
    await axiosInterceptorInstance
      .get(
        `/ThaCrm/getfaq?operatorShortCode=${
          operator?.operatorShortCode ? operator?.operatorShortCode : null
        }&countryIsoCode=${country.isoCode2}`
      )
      .then((response) => {
        setCircle(false);
        const responseData = response?.data.payload;
        if (responseData) {
          setFaqs(responseData);
        } else {
          setFaqs([]);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };
  const getFAQByCountry = async () => {
    setCircle(true);
    await axiosInterceptorInstance
      .get(`/ThaCrm/GetFaqByCountry?countryIsoCode=${country.isoCode2}`)
      .then((response) => {
        setCircle(false);
        const responseData = response?.data.payload;
        if (responseData) {
          setFaqs(responseData);
        } else {
          setFaqs([]);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };
  const AddFaq = async () => {
    setSubmitRequest(true);
    await axiosInterceptorInstance
      .post(`/ThaCrm/addfaq`, {
        question: question,
        answer: display_faq,
        operatorName: operator?.operatorName ? operator?.operatorName : null,
        operatorShortCode: operator?.operatorShortCode
          ? operator?.operatorShortCode
          : null,
        countryIsoCode: country.isoCode2,
        isRedeem: redeem,
      })
      .then((res: any) => {
        const data = res.data;
        toast.success(data.message);
        getFAQ();
        ClearFaq();
      })
      .catch((error: any) => {
        setSubmitRequest(false);
      })
      .finally(() => {
        setSubmitRequest(false);
      });
  };
  const AddFaqByCountry = async () => {
    setSubmitRequest(true);
    await axiosInterceptorInstance
      .post(`/ThaCrm/addfaqbycountry`, {
        question: question,
        answer: display_faq,
        CountryName: country.countryName,
        countryIsoCode: country.isoCode2,
        isRedeem: redeem,
      })
      .then((res: any) => {
        const data = res.data;
        toast.success(data.message);
        getFAQByCountry();
        ClearFaq();
      })
      .catch((error: any) => {
        setSubmitRequest(false);
      })
      .finally(() => {
        setSubmitRequest(false);
      });
  };
  const UpdateFaq = async () => {
    setSubmitRequest(true);
    await axiosInterceptorInstance
      .post(`/ThaCrm/updatefaq`, {
        faqId: edit_faqs.faqId,
        question: question,
        answer: display_faq,
        operatorName: operator?.operatorName ? operator?.operatorName : null,
        operatorShortCode: operator?.operatorShortCode
          ? operator?.operatorShortCode
          : null,
        countryIsoCode: country.isoCode2,
        isRedeem: redeem,
      })
      .then((res: any) => {
        const data = res.data;
        toast.success(data.message);
        getFAQ();
        ClearFaq();
      })
      .catch((error: any) => {
        setSubmitRequest(false);
      })
      .finally(() => {
        setSubmitRequest(false);
      });
  };
  const UpdateFaqByCountry = async () => {
    setSubmitRequest(true);
    await axiosInterceptorInstance
      .post(`/ThaCrm/updatefaqbycountry`, {
        faqId: edit_faqs.faqId,
        question: question,
        answer: display_faq,
        CountryName: country.countryName,
        countryIsoCode: country.isoCode2,
        isRedeem: redeem,
      })
      .then((res: any) => {
        const data = res.data;
        toast.success(data.message);
        getFAQByCountry();
        ClearFaq();
      })
      .catch((error: any) => {
        setSubmitRequest(false);
      })
      .finally(() => {
        setSubmitRequest(false);
      });
  };

  const deleteFAQ = async () => {
    setAction(true);
    await axiosInterceptorInstance
      .delete(`ThaCrm/deletefaq?faqId=${delete_faq.faqId}`)
      .then((res: any) => {
        const data = res.data;
        setDeleteCheck(false);
        setAction(false);
        CheckDeletionAndGetFaq();
        toast.success(data.message);
      })
      .catch((error: any) => {
        setAction(false);
        setDeleteCheck(false);
      });
  };

  const ClearFaq = () => {
    setIsCheck(false);
    setQuestion("");
    setRedeem(false);
    setEditorFaqState(EditorState.createEmpty());
    setDisplayFaq("");
    setEditFaqs([]);
  };
  const CheckFaqAndDescription = () => {
    if (isCheck && display_faq != "" && question != "") {
      UpdateFaq();
    } else if (display_faq != "" && question != "") {
      AddFaq();
    } else {
      toast.error("Please enter the required inputs.");
    }
  };
  const CheckFaqAndDescriptionByCountry = () => {
    if (isCheck && display_faq != "" && question != "") {
      UpdateFaqByCountry();
    } else if (display_faq != "" && question != "") {
      AddFaqByCountry();
    } else {
      toast.error("Please enter the required inputs.");
    }
  };
  const CheckDeletionAndGetFaq = () => {
    const isOperatorValid = operator !== 0 && operator !== undefined;
    // Section 2 logic
    if (!isOperatorValid) {
      getFAQByCountry();
    } else {
      getFAQ();
    }
  };
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ ease: "linear", duration: 0.5 }}
    >
      <div className="boxShadow">
        <h2 className="sectionTitle">Operator CMS</h2>
        <div className="boxInner">
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <fieldset>
                <legend>General Information:</legend>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    {countryListN && (
                      <FormControl style={{ width: "100%" }}>
                        <InputLabel
                          id="demo-simple-select-label"
                          style={{ background: "#fff", padding: " 0 5px" }}
                        >
                          Countries
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          className="formControl"
                          autoWidth
                          value={country?.isoCode2 || "0"}
                          defaultValue={country?.isoCode2 || "0"}
                          onChange={(e: any) => {
                            const country = countryListN?.find(
                              (item) => item.isoCode2 === e.target.value
                            );
                            setCountry(country);
                          }}
                        >
                          <MenuItem value="0">Select Country</MenuItem>
                          {countryListN.map((item, index) => (
                            <MenuItem key={index} value={item?.isoCode2}>
                              {item?.countryName}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    )}
                  </Grid>

                  <Grid item xs={6}>
                    <FormControl style={{ width: "100%" }}>
                      <InputLabel
                        id="demo-simple-select-label"
                        style={{ background: "#fff", padding: " 0 5px" }}
                      >
                        Product Type
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        className="formControl"
                        autoWidth
                        value={product}
                        defaultValue={product}
                        onChange={(e: any) => {
                          setProduct(e.target.value);
                        }}
                      >
                        <MenuItem value="0">Choose Type</MenuItem>
                        <MenuItem value="gift_cards"> Gift Card </MenuItem>
                        <MenuItem value="mobile">Mobile</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              </fieldset>
            </Grid>
            {circular == true && rowData.length == 0 && (
              <div className="circular-loader">
                <CircularProgress size={40} />
              </div>
            )}
            {isOpen && rowData.length > 0 && (
              <Grid item xs={12}>
                <fieldset>
                  <legend>Operator Selection:</legend>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <FormControl style={{ width: "100%" }}>
                        <InputLabel
                          id="demo-simple-select-label"
                          style={{ background: "#fff", padding: " 0 5px" }}
                        >
                          Operator
                        </InputLabel>

                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          className="formControl"
                          autoWidth
                          value={operator?.operatorId || "0"}
                          defaultValue={operator?.operatorId || "0"}
                          onChange={(e: any) => {
                            const operator = rowData?.find(
                              (item: any) => item.operatorId === e.target.value
                            );

                            setOperator(operator);
                          }}
                        >
                          <MenuItem value="0">Choose Type</MenuItem>

                          {rowData?.map((item: any, index: any) => (
                            <MenuItem key={index} value={item?.operatorId}>
                              {item?.operatorName}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>

                    <Grid item xs={6}>
                      <FormControl style={{ width: "100%" }}>
                        <InputLabel
                          id="demo-simple-select-label"
                          style={{ background: "#fff", padding: " 0 5px" }}
                        >
                          Section
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          className="formControl"
                          autoWidth
                          value={section}
                          defaultValue={section}
                          onChange={(e: any) => {
                            setSection(e.target.value);
                          }}
                        >
                          <MenuItem value="0">Choose Type</MenuItem>
                          <MenuItem value="1"> About</MenuItem>
                          <MenuItem value="2">FAQ</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>
                </fieldset>
              </Grid>
            )}
            {section != 0 &&
              Open &&
              operator != "0" &&
              operator != undefined && (
                <Grid item xs={12}>
                  <fieldset>
                    <legend>Operator Information:</legend>
                    <Grid container spacing={2}>
                      <Grid item xs={6}>
                        <TextField
                          className="formControl"
                          label="Title"
                          variant="outlined"
                          value={title}
                          inputProps={{ maxLength: 200 }}
                          onChange={(e: any) => {
                            setTitle(e.target.value);
                          }}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <TextField
                          className="formControl"
                          label="Short Code"
                          variant="outlined"
                          value={shortCode}
                          inputProps={{ maxLength: 200, readOnly: true }}
                          onChange={(e: any) => {
                            setShortCode(e.target.value);
                          }}
                        />
                      </Grid>
                    </Grid>
                  </fieldset>
                </Grid>
              )}

            {section == 1 &&
              country != undefined &&
              country != "0" &&
              product != "0" && (
                <Grid item xs={12}>
                  <h2>About Editor</h2>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <TextField
                        className="formControl"
                        label="CustomPageTitle"
                        variant="outlined"
                        value={customPageTitle}
                        multiline={true}
                        rows={3}
                        onChange={(e: any) => {
                          setCustomPageTitle(e.target.value);
                        }}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        className="formControl"
                        label="EXCERPT"
                        variant="outlined"
                        value={excerpt}
                        multiline={true}
                        rows={3}
                        onChange={(e: any) => {
                          setExcerpt(e.target.value);
                        }}
                      />
                    </Grid>
                  </Grid>

                  <div className="boxShadow editor">
                    <Editor
                      editorState={editorState}
                      toolbarClassName="toolbarClassName"
                      wrapperClassName="wrapperClassName"
                      editorClassName="editorScrollable"
                      onEditorStateChange={onEditorStateChange}
                    />
                  </div>
                </Grid>
              )}

            {section == 2 &&
              faqs.length !== 0 &&
              country !== undefined &&
              country !== "0" &&
              product !== "0" &&
              !circle && (
                <div className="faq-list-container">
                  <h2>Frequently Asked Questions</h2>
                  <Grid item xs={12}>
                    {faqs.map((faq: any, index: number) => (
                      <div key={index} className="faq-item">
                        <div className="faq-header">
                          <h3 style={{ padding: "0" }}>
                            Q{faq.faqId}:{faq.question}
                          </h3>
                          <div className="faq-header">
                            {faq.isRedeem ? (
                              <p className="Redeem">Redeem</p>
                            ) : null}
                            <DriveFileRenameOutlineOutlinedIcon
                              className="edit-button"
                              style={{ marginRight: "20px" }}
                              onClick={() => {
                                setEditFaqs(faq), setIsCheck(true);
                              }}
                            ></DriveFileRenameOutlineOutlinedIcon>
                            <DeleteIcon
                              className="edit-button"
                              onClick={() => {
                                setDeleteFaq(faq), setDeleteCheck(true);
                              }}
                            ></DeleteIcon>
                          </div>
                        </div>
                        <p dangerouslySetInnerHTML={{ __html: faq.answer }} />
                        <hr />
                      </div>
                    ))}
                  </Grid>
                </div>
              )}
            {circle && (
              <div className="circular-loader">
                <CircularProgress size={40} />
              </div>
            )}
            {section == 2 &&
              country != undefined &&
              country != "0" &&
              product !== "0" && (
                <Grid item xs={12}>
                  <h2
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    FAQ Section{" "}
                    <Button
                      className="dButton "
                      variant="contained"
                      style={{ width: "10%", height: "35px" }}
                      onClick={() => ClearFaq()}
                    >
                      Clear
                    </Button>
                  </h2>

                  <Grid item xs={12}>
                    <TextField
                      className="formControl"
                      label="Question"
                      variant="outlined"
                      value={question}
                      inputProps={{ maxLength: 200 }}
                      onChange={(e: any) => {
                        setQuestion(e.target.value);
                      }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <FormControlLabel
                      style={{ marginLeft: "0px" }}
                      control={
                        <Checkbox
                          checked={redeem}
                          onChange={(e: any) => setRedeem(e.target.checked)}
                          inputProps={{ "aria-label": "controlled" }}
                          size="medium"
                        />
                      }
                      label="Redeem"
                      labelPlacement="start"
                    />
                  </Grid>
                  <h2>Answer</h2>
                  <div className="boxShadow editor">
                    <Editor
                      editorState={editorFaqState}
                      toolbarClassName="toolbarClassName"
                      wrapperClassName="wrapperClassName"
                      editorClassName="editorScrollable"
                      onEditorStateChange={onEditorFaqChange}
                    />
                  </div>
                </Grid>
              )}
            <Grid item xs={12}>
              <Grid container spacing={2}>
                <Grid item xs={3} style={{ marginLeft: "30%" }}>
                  {!submitRequest &&
                    country != undefined &&
                    country != "0" &&
                    product !== "0" &&
                    section != 0 && (
                      <Button
                        className="dButton "
                        variant="contained"
                        onClick={() => handleSave()}
                      >
                        Save
                      </Button>
                    )}
                  {submitRequest && (
                    <Button className="dButton " variant="contained">
                      <CircularProgress color="inherit" size={30} />
                    </Button>
                  )}
                </Grid>
                <Grid item xs={3}>
                  {display_description &&
                    country != undefined &&
                    country != "0" &&
                    product !== "0" &&
                    section == 1 && (
                      <Button
                        className="dButton "
                        variant="contained"
                        onClick={() => setPreview(true)}
                      >
                        Preview
                      </Button>
                    )}
                </Grid>
              </Grid>
            </Grid>

            <Dialog
              className="operator-preview"
              open={preview}
              onClose={() => setPreview(false)}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <div dangerouslySetInnerHTML={{ __html: display_description }} />
            </Dialog>

            <Dialog
              open={deleteCheck}
              onClose={() => setDeleteCheck(false)}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                {"Delete FAQ Confirmation"}
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  Would you really like to delete this FAQ?
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button
                  variant="contained"
                  className="dButton dButton2 dbuttonSec"
                  onClick={() => setDeleteCheck(false)}
                >
                  No
                </Button>
                <div style={{ width: "30px" }}></div>
                {!action && (
                  <Button
                    variant="contained"
                    className="dButton dButton2"
                    onClick={() => {
                      deleteFAQ();
                    }}
                    autoFocus
                  >
                    Yes
                  </Button>
                )}
                {action && (
                  <Button className="dButton dButton2" variant="contained">
                    <CircularProgress color="inherit" size={30} />
                  </Button>
                )}
              </DialogActions>
            </Dialog>
          </Grid>
        </div>
      </div>
    </motion.div>
  );
};

export default ThaOperatorCms;
